import React from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import Input from "../Atoms/Input";
import Select from "../Atoms/Select";
import CheckboxPublicPrivate from "../Atoms/CheckboxPublicPrivate";
import H1 from "../Atoms/H1";
import Textarea from "../Atoms/Textarea";
import ImageUpload from "../Atoms/ImageUpload";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PaymentPopup, { PaymentPopupV2 } from "../Components/PaymentPopup";
import { NeedToPay, cat_gories_viaContainsVIACategory, validateFrom } from "../Utils/Validator";
import Section from "../Atoms/Section";
import BlueButton from "../Atoms/BlueButton";
import SocialNetworks from "../Atoms/SocialNetworks";
import AddAnItem from "../Atoms/AddAnItem";
import MiniatureContainer from "../Atoms/MiniatureContainer";
import Miniature from "../Atoms/Miniature";
import Spinner from "../../Plateforme/Atoms/Spinner";
import Collaborators from "../Components/Collaborators";
import GetProjectMainImage from "../Utils/GetProjectMainImage";
import AwardsDisplay from "../Atoms/AwardsDisplay";
import AwardsAdd from "../Atoms/AwardsAdd";
import { CountrySelectOptions } from "../Utils/Listings";
import EditClientèle from "../Atoms/EditClientèle";
import EditPositionnement from "../Atoms/EditPositionnement";
import styled from "styled-components";
import AddCollaborator from "../Components/AddCollaborator";
import DefaultCompanyCover from "../Utils/DefaultCompanyCover";
import EditActivité from "../Atoms/EditActivité";
import EditSavoirFaire from "../Atoms/EditSavoirFaire";
import EditSecteurs from "../Atoms/EditSecteurs";
import PopupGoToSDE24 from "../Components/SDE24/PopupGoToSDE24";
import PopupGoToFD10025 from "../Components/FD10025/PopupGoToFD10025";
import UploadProgressBar from "../Atoms/UploadProgressBar";
import H0 from "../Atoms/H0";
import BoldBlue from "../Atoms/BoldBlue";
import { getStoredRedirect, clearStoredRedirect, createUrlWithRedirect } from "../Utils/redirectUtils";

const ChampsAdhérentContainer = styled.div`
    border-bottom: 1px solid #ccc;
    padding: 10px 0;

    .value {
        text-align: right;

        > span {
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            width: 90px;

            img {
                width: 35px;
                margin: 0 0 0 10px;
            }
        }
    }
`;

const MyCompany = (props) => {

    const [user, setUser] = React.useState({});
    const [PaymentPopupOpen, setPaymentPopupOpen] = React.useState(false);
    const [eventPopupOpen, setEventPopupOpen] = React.useState(false);
    const [awards, setAwards] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [activitéEntreprise, setActivitéEntreprise] = React.useState("");
    const [uploadProgress, setUploadProgress] = React.useState(0);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const snap_to_projects = urlParams.get('snap_to_projects');
    const project_section_ref = React.useRef(null);

    //if a snap_to_projects=true is in the url, we need to scroll to the projects section
    React.useEffect(() => {
        console.log("snap_to_projects", snap_to_projects);
        console.log("project_section_ref", project_section_ref);
        // if snap_to_projects and the section ref is set
        if(snap_to_projects && project_section_ref.current){
            //scroll to the section
            setTimeout(() => {
                project_section_ref.current.scrollIntoView();
            }, 100);
            console.log("scrolling to projects section");
        }
    }, [snap_to_projects, user]);

    React.useEffect(() => {
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate(createUrlWithRedirect('/login', location.pathname + location.search));
        if(props.fullUser?.user && props.fullUser.user.role === "admin" && id){
            getProfile()
        }else{
            setUser(props.fullUser);
            setAwards(props.fullUser?.hsCompany?.properties?.awards || "[]");
        }
    }, [props.fullUserLoading, props.fullUser, id]);

    function getProfile(){
        api.GetAllUserData({email : atob(id)}).then((response) => {
            setUser(response.data);
            setAwards(response.data?.hsCompany?.properties?.awards || "[]");
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        })
    }

    if(loading || props.fullUserLoading || !user){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
                <br/>
                <UploadProgressBar uploadProgress={uploadProgress}/>
            </>
        )
    }

    function viewInPublicMode(event){
        event.preventDefault();
        navigate('/company?id=' + user.company?._id);
    }

    function onUploadProgress(progressEvent){
        const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setUploadProgress(percentCompleted);
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        const submission = new FormData(event.target);
        if(!validateFrom(submission)) return;
        if(!user.hsCompany?.properties?.name && !activitéEntreprise) {
            alert(i18n.language === "fr" ? "Veuillez renseigner l'activité de l'entreprise" : "Please fill in the company activity");
            setLoading(false);
            return;
        }

        submission.append('userid', user.user._id);
        
        api.UpdateCompany(submission, onUploadProgress).then((response) => {
            // console.log(response.data);
            if(response.data === "file too big"){
                setLoading(false);
                alert(i18n.language === "fr" ? "Le fichier est trop volumineux." : "The file is too big.");
            }
            if(id){
                getProfile()
            }else{
                props.refreshUser().then((updatedUser) => {
                    // Check for stored redirect after successful company update
                    const storedRedirect = getStoredRedirect();
                    if (storedRedirect && updatedUser?.company?._id) {
                        // User has completed company registration, apply redirect
                        clearStoredRedirect();
                        navigate(storedRedirect);
                    } else {
                        setEventPopupOpen(true);
                        setLoading(false);
                    }
                });

                // if(NeedToPay(user.hsProfile)){
                //     // setPaymentPopupOpen(true);
                //     setLoading(false);
                // }else{
                //     navigate('/annuaire');
                // }
            }
        }).catch((error) => {
            console.log(error);
            setLoading(false);
        })
    }

    function stringDateToYear(stringDate){
        if(!stringDate) return "";
        return stringDate.split("-")[0];
    }

    const adhérentCodifab = user.hsProfile?.adherent?.includes("CODIFAB")
    const adhérentAmeublementFrançais = user.hsProfile?.adherent?.includes("Ameublement Français")

    return (
        <form onSubmit={event => handleSubmit(event)}>
            <Section>
                <ImageUpload
                    currentImagePath={user.company?.cover_picture ? (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.company?.cover_picture) : ''}
                    creditFieldDefaultValue={user.company?.coverCredit}
                    textFR="une photo de couverture"
                    textEN="a cover picture"
                    name="coverpicture"
                    creditFieldName="creditcover"
                    width="100%"
                    height="400px"
                />
            </Section>
            <Section className="padding flexblock" style={{alignItems:'center'}}>
                <H0 style={{width:'max(calc(100% - 350px),300px)'}}><Input style={{width:'100%',fontSize:'35px',fontWeight:'600'}} name="name" required placeholder={i18n.language === "fr" ? "Nom de la société" : "Company name"} defaultValue={user.hsCompany?.properties?.name?.toUpperCase() || ''}/></H0>
                {user.user?.companyHubspotID && cat_gories_viaContainsVIACategory(user.hsProfile?.cat_gories_via) &&
                    <BoldBlue onClick={event => viewInPublicMode(event)} style={{display:"inline-block", cursor:'pointer'}}>
                        <img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Aperçu en mode public" : "Preview in public mode"}
                    </BoldBlue>
                }
            </Section>
            <Section className="flexblock">
                <div>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Informations société" : "Company informations"}</H2><br/><br/>
                    {!user.hsCompany?.properties?.name && <><EditActivité onChange={setActivitéEntreprise} style={{width:"100%"}} name="activité"/><br/><br/></>}
                    {(activitéEntreprise.includes("Producteur - Fabricant") || activitéEntreprise.includes("Créateur - Artisan d'art")) && <><EditSavoirFaire style={{width:"100%"}} name="savoirfaire"/><br/><br/></>}
                    {activitéEntreprise.includes("Producteur - Fabricant") && <><EditSecteurs style={{width:"100%"}} name="secteur"/><br/><br/></>}
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Année de création" : "Year of creation"}</span>
                        <Input type="number" name="date_de_creation_de_l_entreprise" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "XXXX" : "XXXX"}  defaultValue={stringDateToYear(user.hsCompany?.properties?.date_de_creation_de_l_entreprise)}/>
                    </div><br/>
                    <EditClientèle name="clientele" style={{width:"100%"}} defaultValue={user.hsCompany?.properties?.clientele}/><br/><br/>
                    <EditPositionnement name="positionnement" style={{width:"100%"}} defaultValue={user.hsCompany?.properties?.positionnement}/><br/><br/>
                    <ChampsAdhérentContainer className="flexblock">
                        <span>{i18n.language === "fr" ? "Cotisant CODIFAB" : "CODIFAB member"}</span>
                        <span className="value">{adhérentCodifab ? <span>{i18n.language === "fr" ? "Oui" : "Yes"}<img src="/img/toggle_on.png" alt=""/></span> : <span>{i18n.language === "fr" ? "Non" : "No"}<img src="/img/toggle_off.png" alt=""/></span>}</span>
                    </ChampsAdhérentContainer><br/>
                    <ChampsAdhérentContainer className="flexblock">
                        <span>{i18n.language === "fr" ? "Adhérent Ameublement Français" : "Ameublement Français member"}</span>
                        <span className="value">{adhérentAmeublementFrançais ? <span>{i18n.language === "fr" ? "Oui" : "Yes"}<img src="/img/toggle_on.png" alt=""/></span> : <span>{i18n.language === "fr" ? "Non" : "No"}<img src="/img/toggle_off.png" alt=""/></span>}</span>
                    </ChampsAdhérentContainer><br/>
                </div>
                <div>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Contact et réseaux" : "Contact and networks"}</H2><br/><br/>
                    <div className="flexblock">
                        <Input name="address" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Adresse" : "Address"} defaultValue={user.hsCompany?.properties?.address}/>
                        <Input name="zip" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Code postal" : "Post code"} defaultValue={user.hsCompany?.properties?.zip}/>
                    </div><br/>
                    <div className="flexblock">
                        <Input name="city" style={{width:"100%",padding:"12px 0px"}} required placeholder={i18n.language === "fr" ? "Ville" : "City"} defaultValue={user.hsCompany?.properties?.city}/>
                        <Select name="country" style={{width:"100%"}} defaultValue={user.hsCompany?.properties?.country}>
                            <CountrySelectOptions/>
                        </Select>
                    </div><br/>
                    <Input name="website" required style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Site web" : "Website"} defaultValue={user.hsCompany?.properties?.website}/><br/><br/>
                    <Input name="work_email" required style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={user.hsCompany?.properties?.work_email}/><br/><br/>
                    <Input name="phone" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Téléphone" : "Phone"} defaultValue={user.hsCompany?.properties?.phone}/><br/><br/>
                    <SocialNetworks
                        twitter={user.hsCompany?.properties?.twitterhandle}
                        instagram={user.hsCompany?.properties?.compte_instagram}
                        linkedin={user.hsCompany?.properties?.linkedin_company_page}
                    /><br/>
                </div>
            </Section>
            <Section className="flexblock">
                <div>
                    <br/>
                    <ImageUpload
                        currentImagePath={user.company?.logo && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.company?.logo)}
                        creditFieldDefaultValue={user.company?.logoCredit}
                        textFR="un logo"
                        textEN="a logo"
                        name="logo"
                        creditFieldName="creditlogo"
                        width="400px"
                        height="400px"
                    />
                    <br/>
                </div>
                <div>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Informations complémentaires" : "Additional information"}</H2><br/><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Nombre de salariés" : "Number of employees"}</span>
                        <Input type="number" name="nombre_d_employes" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Nombre de salariés" : "Number of employees"}  defaultValue={user.hsCompany?.properties?.numberofemployees}/>
                    </div><br/>
                    <div className="flexblock" style={{display:"none"}}>{/*Temporarily hidden*/}
                        <span>{i18n.language === "fr" ? "Chiffre d'affaires" : "Turnover"}</span>
                        <Input name="annualrevenue" type="number" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Chiffre d'affaires" : "Turnover"} defaultValue={user.hsCompany?.properties?.annualrevenue}/>€
                        <CheckboxPublicPrivate name="showchiffre_d_affaire_de_l_entreprise" defaultChecked={user.company?.showchiffre_d_affaire_de_l_entreprise}/>
                    </div><br/>
                    <Input name="email_agence_rp" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Email de votre agence RP" : "Your PR agency email"} defaultValue={user.hsCompany?.properties?.email_agence_rp}/><br/><br/>
                </div>
            </Section>
            <Section className="flexblock">
                <div>
                    <H2>{i18n.language === "fr" ? "À propos" : "About"}</H2><br/><br/>
                    <span>{i18n.language === "fr" ? "Français" : "French"}</span><br/>
                    <Textarea name="aboutfr" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "À propos*" : "About*"} required defaultValue={user.hsCompany?.properties?.description_courte_fr}/><br/><br/>
                    <span>{i18n.language === "fr" ? "Anglais" : "English"}</span><br/>
                    <Textarea name="abouten" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "À propos" : "About"} defaultValue={user.hsCompany?.properties?.description_courte_en}/><br/><br/>
                </div>
                <div className="secondary-block">
                    <br/><br/><br/><br/>
                    <AwardsDisplay
                        inputName="awards"
                        awards={awards}
                        setAwards={setAwards}
                    />
                    <br/>
                    <AwardsAdd
                        awards={awards}
                        setAwards={setAwards}
                    />
                    <br/><br/>
                    {user?.company?._id && <>
                        <Collaborators company={user}/>
                        <AddCollaborator inviter={user}/>
                    </>}
                </div>
            </Section>
            {user.company && <>
                <Section className="padding" ref={project_section_ref}>
                    <H1>{i18n.language === "fr" ? "PROJETS" : "PROJECTS"}</H1>
                </Section>
                <Section className="padding">
                    <br/>
                    {user.company?._id ? <MiniatureContainer>
                        <AddAnItem
                            textFR="un projet"
                            textEN="a project"
                            width="400px"
                            height="400px"
                            onClick={() => navigate(id ? '/myproject?as=' + id : '/myproject')}
                        />
                        {user.company?.projects && user.company.projects.map((project) => {
                            return (
                                <Link to={id ? '/myproject?id='+project._id+'&as='+id : '/myproject?id='+project._id} key={project._id}>
                                    <Miniature
                                        imagePath={GetProjectMainImage(project)}
                                        title={project.name}
                                        privacy={project.public === "on" || project.public === true}
                                        tag={i18n.language === "fr" ? "Projet" : "Project"}
                                        keyInfo={project.adresse}
                                        category={project.fabrication_fr === "oui" ? (i18n.language === "fr" ? "Fabrication française" : "French manufacturing") : null}
                                    />
                                </Link>
                            )
                        })}
                    </MiniatureContainer> : <span>{i18n.language === "fr" ? "Enregistrez votre société pour ajouter des projets" : "Save your company to add projects"}</span>}
                    <br/>
                </Section>
            </>}
            <Section className="padding">
                <BlueButton className="centered"><img src='/img/fleche_blanche.png' alt='' />
                    {NeedToPay(user.hsProfile) ? i18n.language === "fr" ? "Enregistrer" : "Save" :''}
                    {!NeedToPay(user.hsProfile) && !user.company ? i18n.language === "fr" ? "Enregistrer et mettre en ligne" : "Save and publish" :''}
                    {!NeedToPay(user.hsProfile) && user.company ? i18n.language === "fr" ? "Enregistrer" : "Save" :''}
                </BlueButton>
            </Section>
            
            {PaymentPopupOpen && <PaymentPopupV2 title={i18n.language === "fr" ? "Données enregistrées" : "Data saved"} close={() => setPaymentPopupOpen(false)} email={user.hsProfile.email}/>}
            {/* {eventPopupOpen && <PopupGoToSDE24 close={() => setEventPopupOpen(false)}/>} */}
            {eventPopupOpen && <PopupGoToFD10025 close={() => setEventPopupOpen(false)}/>}
        </form>
    );
};

export default MyCompany;